import { render, staticRenderFns } from "./ClbrtnHist.vue?vue&type=template&id=40ce04b0&scoped=true"
import script from "./ClbrtnHist.vue?vue&type=script&lang=js"
export * from "./ClbrtnHist.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40ce04b0",
  null
  
)

export default component.exports